systemSettingsMenuButton = {};

systemSettingsMenuButton.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addCanSpinFlag(button);
	
    button.canEnable = function() {
        return true;
    };
    
    button.onPressedCallback = function() {
        let systemSettingsBox = resourceManager.get('systemSettings:systemSettingsBox');
		systemSettingsBox.showsystemSettingsBoxPanel(true);
    };

    return button;
};

systemSettingsMenuButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
systemSettingsMenuButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("systemSettingsMenuButton", systemSettingsMenuButton.create, systemSettingsMenuButton.initialise, systemSettingsMenuButton.getFilesRequired);